// extracted by mini-css-extract-plugin
export default {"containerWrapper":"CardSellersContainer_containerWrapper__Y4zaf","slider":"CardSellersContainer_slider__mKg+q","cardWrapper":"CardSellersContainer_cardWrapper__r-O2t"};